import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { claim_notification_form_keys, declarant_claim_notification_form_keys, declarant_claim_notification_persona_fisica_controls, declarant_claim_notification_persona_giuridica_controls, declarant_claim_notification_PF_validators, declarant_claim_notification_PG_validators } from './claim-notification-isv.constants';

@Component({
  selector: 'app-claim-notification-isv',
  templateUrl: './claim-notification-isv.component.html',
  styleUrl: './claim-notification-isv.component.scss'
})
export class ClaimNotificationIsvComponent implements OnInit, OnDestroy {

  @Input() form: FormGroup;
  @Input() additionalForm: FormGroup;

  formKeys: IFormKey[] = CommonUtils.assign(claim_notification_form_keys);
  additionalFormKeys: IFormKey[] = CommonUtils.assign(declarant_claim_notification_form_keys);

  destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.patchAdditionalForm(this.additionalForm.get('naturaGiuridica')?.value);
    this.watchAdditionalForm();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  watchAdditionalForm(): void {
    this.additionalForm?.get('naturaGiuridica')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: string) => {
        this.patchAdditionalForm(value);
      });
  }

  patchAdditionalForm(naturaGiuridica?: string) {
    if (!naturaGiuridica) return;
    if (naturaGiuridica === 'personaFisica') {
        this.manageDeclarantFields(
            declarant_claim_notification_persona_fisica_controls,
            declarant_claim_notification_PF_validators,
            declarant_claim_notification_persona_giuridica_controls
        );
    } else {
        this.manageDeclarantFields(
            declarant_claim_notification_persona_giuridica_controls,
            declarant_claim_notification_PG_validators,
            declarant_claim_notification_persona_fisica_controls
        );
    }
  }

  manageDeclarantFields(controlsToShow: string[], validators: any, controlsToHide: string[]): void {
    controlsToShow.forEach(controlName => {
      if (!this.additionalForm.contains(controlName)) {
        this.additionalForm.addControl(controlName, new FormControl(null, validators[controlName]));
      }
      const key = this.additionalFormKeys.find(key => key.controlName === controlName);
      if (key) {
          key.hidden = false;
      }
    });

    controlsToHide.forEach(controlName => {
      if (this.additionalForm.contains(controlName)) { 
        this.additionalForm.removeControl(controlName);
        const key = this.additionalFormKeys.find(key => key.controlName === controlName);
        if (key) {
          key.hidden = true;
        }
      }
    })
  }

}
